import React from 'react';

import { TextArea } from '@components/common';

import Button from '../../Button';

function DescriptionModal({ description, onClose }: {
	description: string;
	onClose: () => void;
}) {
	return (
		<div className='f5gConfirmContainer'>
			<TextArea
				disabled
				name=''
				rows={7}
				value={description}
			/>
			<div className='f5gConfirmActions'>
				{onClose
					&& (
						<Button
							large
							onClick={onClose}
							text='Close'
						/>
					)
				}
			</div>
		</div>
	);
}

export default DescriptionModal;
